$(document).ready(function(){
    
  $('.review_slide_row').slick({
    dots: true,
    slidesToShow:4,
    slidesToScroll: 1,
    adaptiveHeight: false,
    variableWidth: false,
    centerMode: false,
    arrows:true,
    responsive: [
      {
        breakpoint: 1023,
        settings: {
        slidesToShow:3,
        slidesToScroll: 1,
        centerMode: false,
        }
      },
      
      {
        breakpoint: 767,
        settings: {
        slidesToShow:1,
        slidesToScroll: 1,
        centerMode: true,
        variableWidth: true,
        arrows:false,
        }
      },
    ] 
  });

  function ugcVideo() {
    var video = $('#myVdo video')[0];
    
    $('.ugc1').click(function(e) {
      $('.ugc-modal').addClass('active');
      $('.video-container').show();
      
      var videoFile = $(this).attr('data-vdo');
      video.src = videoFile;
      video.load();
      video.play();
      });	
    
    $('.ugc-close, .ugc-modal').click(function(e) {
      video.src = '';
           $('.ugc-modal').removeClass('active');
         $('.video-container').hide();
    });
    
  }
  ugcVideo();

});